import { PHOTO_UPLOAD_URL } from "../config";

/**
 * Upload a photo file to Google Drive via the Apps Script endpoint.
 * Returns the thumbnail URL on success.
 *
 * @param {File} file - The image file to upload
 * @param {string} identifier - A prefix for the filename (e.g., slot ID or storyteller ID)
 * @param {string} name - Human-readable name for the filename
 * @returns {Promise<string>} The Google Drive thumbnail URL
 */
export function uploadPhotoToGDrive(file, identifier, name) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const base64 = reader.result.split(",")[1];
        const safeName = (name || "unknown").replace(/[^a-zA-Z0-9]/g, "");
        const ext = file.type === "image/png" ? "png" : "jpg";
        const res = await fetch(PHOTO_UPLOAD_URL, {
          method: "POST",
          body: JSON.stringify({
            image: base64,
            mimeType: file.type,
            fileName: `${identifier}_${safeName}_photo_${Date.now()}.${ext}`,
          }),
        });
        const result = await res.json();
        if (result.success) {
          resolve(result.thumbnailUrl);
        } else {
          reject(new Error(result.error || "Upload failed"));
        }
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.readAsDataURL(file);
  });
}
